import { isNotNil } from '@wrisk/ui-components'
import { FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const StringFormatter: FunctionComponent<Formatter<string>> = ({ value, t }) =>
  isNotNil(value) ? value : t(tDefaults('inputs.no-answer'))
